import { InjectionToken } from '@angular/core';
import { AdminReportsPort } from './admin-reports.port';

export const ADMIN_REPORTS_PORT = new InjectionToken<AdminReportsPort>('ADMIN_REPORTS_PORT');
